import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home1",
  "use": "icon-home1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home1\"><path d=\"M832 64h128v277.696l-128-146.304V64z m64 448L512 73.216 128 512H0L448 0h128l448 512h-128z m0 82.688V1024H640V704c0-35.392-28.608-64-64-64h-128a64 64 0 0 0-64 64v320H128V594.624l384-424.32 384 424.384z\" fill=\"\" p-id=\"4269\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol